import React from 'react';
import ModuleBase from '../../components/ModuleBase/ModuleBase';
import { Typography } from '@douyinfe/semi-ui';
import styles from './style.module.scss';

const { Title, Text } = Typography;

const GroupText = ({ data, onEdit, style }) => {
    const { title, content, titleStyle = {}, contentStyle = {} } = data || {};

    return (
        <ModuleBase onEdit={onEdit} style={style}>
            <div className={styles.groupText}>
                <Title
                    heading={4}
                    style={{
                        marginBottom: '16px',
                        fontSize: titleStyle.fontSize || '20px',
                        color: titleStyle.color || '#1C1F23',
                        backgroundColor: titleStyle.backgroundColor || '',
                        textAlign: titleStyle.textAlign || 'left'
                    }}
                >
                    {title}
                </Title>
                <Text
                    style={{
                        fontSize: contentStyle.fontSize || '14px',
                        color: contentStyle.color || '#666666',
                        backgroundColor: contentStyle.backgroundColor || '',
                        lineHeight: contentStyle.lineHeight || 0,
                        display: 'block',
                        whiteSpace: 'pre-wrap'
                    }}
                >
                    {content}
                </Text>
            </div>
        </ModuleBase>
    );
};

export default GroupText;